import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../../service/service.js';
import {BillingService} from '../../../service/billing/billingService.js';
import {ElementUtil} from '../../../utils/elementUtil.js';
import {TimeUtil} from '../../../utils/timeUtil.js';
import {StringUtil} from '../../../utils/stringUtil.js';
import {BaseComponent} from '../../basecomponent.js';


/* global customElements */
class AdjustmentGrid extends BaseComponent {
	
	static get properties() {
		return {			
		};
	}
	
	constructor() {
		super();		
		
		var adjustmentGrid = this;
		setTimeout(function(){
			adjustmentGrid.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var adjustmentGrid = this;
		
		var toolbar = ElementUtil.create({
			tag: 'dl-toolbar',
			slot: 'toolbar',
			theme: 'spacing',
			children: [
				{
					tag: 'vaadin-button',
					itemid: 'refresh',
					'class': 'spacer-toolbar-item',
					children:[
						ElementUtil.makeIcon('vaadin:refresh', ' Refresh')
					], 
					listeners: {
						click: function() {
							actionRefresh();
						}
					}
				},							
				{
					tag: 'dl-action-button',
					itemid: 'recordPayment',
					theme: 'primary',
					'class': 'spacer-toolbar-item',
					permissions: ['ADMIN_BILLING_ACCOUNTS:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:plus', ' Add')
					],
					listeners: {
						click: function() {							
							actionAddAdjustment();
						}
					}					
				},
				{
					tag: 'dl-action-button',
					itemid: 'remove',
					'class': 'spacer-toolbar-item',
					disabled: true,	
					theme: 'error primary',
					style: 'float: right; width: 355px;',	
					permissions: ['ADMIN_BILLING_ACCOUNTS:DELETE'],
					children:[
						ElementUtil.makeIcon('vaadin:trash', ' Remove Adjustment')						
					],
					properties: {
						menu: [							
							{
								tag: 'vaadin-item',
								trustedInnerHTML: true,
								innerHTML: '<vaadin-icon icon="vaadin:trash"></vaadin-icon> Remove Now (Apply Next Invoice)',
								listeners: {
									click: function(event) {
										actionRemoveAdjustment(grid.selectedItems[0], false, false);
									}
								}
							},
							{
								tag: 'vaadin-item',
								trustedInnerHTML: true,
								innerHTML: '<vaadin-icon icon="vaadin:trash"></vaadin-icon> Remove  (Regenerate Invoice)',
								listeners: {
									click: function(event) {
										actionRemoveAdjustment(grid.selectedItems[0], true, true);
									}
								}
							}
						]
					}
				}				
			]
		});
		
		var grid = ElementUtil.create({
			tag: 'vaadin-grid',
			theme: 'row-stripes column-borders',
			'column-reordering-allowed': '',
			style: 'height: 100%;',
			slot: 'primary',
			defaults: {
				tag: 'vaadin-grid-sort-column',
				resizable: true
			},			
			children: [	
				{						
					path: 'createDts',
					header: 'Date',						
					width: '9em',				
					renderer: function(root, column, rowData) {
						var date = TimeUtil.parseDate(rowData.item.createDts);						
						root.innerHTML = TimeUtil.formatDateOnlyStandard(date);						
					}
				},
				{						
					path: 'adjAppliedCount',
					header: 'Applied Count',						
					width: '9em',
					'text-align': 'center'
				},
				{						
					path: 'updateUser',
					header: 'User',						
					width: '9em'
				},
				{						
					path: 'featureProductName',
					header: 'Product',						
					width: '9em'
				},
				{						
					path: 'correctionTypeDescription',
					header: 'Correction Type',						
					width: '9em'
				},
				{						
					path: 'adjustmentTypeDescription',
					header: 'Adjustment Type',						
					width: '9em'
				},
				{						
					path: 'adjustmentAmt',
					header: 'Amount',
					'text-align': 'end',
					width: '9em',
					renderer: function(root, column, rowData) {
						root.innerHTML = StringUtil.currencyFormat(rowData.item.adjustmentAmt);
					}
				},		
				{						
					path: 'adjustmentDurationAmt',
					header: 'Cycles',
					width: '9em',	
					renderer: function(root, column, rowData) {											
						root.innerHTML = rowData.item.adjustmentDurationAmt	+ ' ' + rowData.item.durationUomDescription;				
					}
				},
				{
					path: 'adjReasonComment',
					header: 'Reason Comment',					
					width: '9em'
				}
			],
			listeners: {
				'active-item-changed': function(event) {
					const item = event.detail.value;
					grid.selectedItems = item ? [item] : [];
					if (grid.selectedItems.length > 0) {						
						ElementUtil.query(toolbar, 'remove').disabled = false;
					} else {						
						ElementUtil.query(toolbar, 'remove').disabled = true;
					}
				}
			}
		});		
			
		var flexLayout = ElementUtil.create({
			tag: 'dl-flex-layout',
			children: [
				toolbar,
				grid
			]
		});		
		adjustmentGrid.append(flexLayout);		
		
		var actionRefresh = function() {
			
			var loadMask = adjustmentGrid.showLoading();
			BillingService.getAccountService().getAccountAdjustments(adjustmentGrid.detail.companyId)
			.then(function(adjustments){							
				loadMask.remove();
				grid.activeItem = null;					
				
				grid.items = adjustments;
			});
		};
		actionRefresh();
				
		var actionAddAdjustment = function() {
			var adjustmentWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'Add Adjustment',
				icon: 'vaadin:plus',
				width: 800,
				height: 375,
				listeners: {
					ready: function() {						
						adjustmentWin.show();
						
						//form
						var formPanel = ElementUtil.create({
							tag: 'dl-form-panel',
							itemid: 'form',
							children: [
								{
									tag: 'vaadin-form-layout',										
									children: [																				
										{
											tag: 'vaadin-combo-box',											
											label: 'Correction Type', 
											name: 'correctionType',
											required: true,
											'item-value-path': 'code',
											'item-label-path': 'description',
											postinit: function(combo) {
												Service.getLookupService().getLookupValues('CorrectionType').then(function(data){
													combo.items = data;
												});
											}
										},
										{
											tag: 'vaadin-combo-box',
											itemid: 'product',
											label: 'Product', 
											name: 'product',
											required: true,
											'item-value-path': 'code',
											'item-label-path': 'description',
											postinit: function(combo) {

												BillingService.getAccountService().getOrders(adjustmentGrid.detail.companyId).then(function(orders){
													var items = [];

													orders.forEach(function(order){
														order.items.forEach(function(itemFull){
															items.push({
																itemFull: itemFull,
																code: itemFull.item.productCode + '-' + itemFull.item.featureProductCode,
																description: itemFull.itemDesc
															});
														});																	

													});

													combo.items = items;
												});

											}
										},
										{
											tag: 'vaadin-combo-box',											
											label: 'Adjustment Type', 
											name: 'adjustmentType',
											required: true,
											'item-value-path': 'code',
											'item-label-path': 'description',
											postinit: function(combo) {
												Service.getLookupService().getLookupValues('AdjustmentType').then(function(data){
													combo.items = data;
												});
											}
										},
										{
											tag: 'vaadin-combo-box',											
											label: 'Adjustment Duration', 
											name: 'adjustmentDurationAmt',
											required: true,
											'item-value-path': 'code',
											'item-label-path': 'description',
											postinit: function(combo) {
												var durations = [];
												for (var i= 1; i<13; i++) {
													durations.push({
														code: i,
														description: i + (i > 1 ? ' Months' : ' Month')
													});
												}												
												combo.items = durations;
											}
										},	
										{
											tag: 'vaadin-number-field',
											label: 'Discount Amount',
											name: 'adjustmentAmt',
											required: true,
											min: -9999999,
											max: 9999999
										},
										{
											tag: 'vaadin-text-field',
											label: 'Reason',
											name: 'adjReasonComment',											
											required: true,
											maxlength: 255
										},
										{
											tag: 'hr',
											colspan: 2
										},
										{
											tag: 'div',
											style: 'text-align: center;',
											colspan: 2,
											defaults: {
												tag: 'vaadin-button'
											},
											children: [
												{
													theme: 'primary',
													children: [
														ElementUtil.makeIcon('vaadin:database', ' Apply Next Cycle')
													],
													listeners: {
														click: function() {															
															actionSaveAdjustment(false, false);															
														}
													}
												},
												{
													theme: 'primary',
													style: 'margin-left: 10px;',
													children: [
														ElementUtil.makeIcon('vaadin:database', ' Apply Correction Now')
													],
													listeners: {
														click: function() {															
															actionSaveAdjustment(true, true);															
														}
													}
												},
												{
													theme: 'tertiary',
													innerHTML: 'Cancel',
													style: 'margin-left: 10px;',
													listeners: {
														click: function() {
															//cancel
															adjustmentWin.close();
														}
													}
												}
											]
										}
									]
								}
							]

						});
						adjustmentWin.addToContentElement(formPanel);
						
						var actionSaveAdjustment = function(applyNow, regenerateInvoice) {
							
							formPanel.submitForm({
								preSubmit: function(data) {	

									var productSelection = ElementUtil.query(formPanel, 'product').selectedItem;
									data.productCode = productSelection.itemFull.item.productCode;
									data.featureProductCode = productSelection.itemFull.item.featureProductCode;
									data.companyId = adjustmentGrid.detail.companyId;
									data.currencyCode = 'USD';
									data.durationUom = 'M';									

									return data;
								},
								actualCall: function(data) {			
									
									var options = {
										applyImmediately: applyNow,
										regenerateInvoice: regenerateInvoice
									};									
									return BillingService.getAccountService().saveAdjustment(adjustmentGrid.detail.companyId, data, options);
								},
								success: function(data, responseData) {
									window.DL.MessageUtil.showToast('Success', 'Added Adjustment', {
										theme: 'success',
										position: 'top-stretch'
									});																	
									actionRefresh();
									adjustmentWin.close();
								}
							});
							
						};
						
					}
				}
			});	
		};
		
		var actionRemoveAdjustment = function(record, applyNow, reInvoice) {
			
			var invoiceMessage = reInvoice ? ' (Re-Invoice)' : ' ';
			var removeMessage = applyNow ? ' remove NOW ' : ' cancel next cycle ';
			
					
			window.DL.MessageUtil.showConfirm({
				title: 'Confirm Removal',
				message: 'Are you sure you want to' + removeMessage + ' selected items ' + invoiceMessage + '?',
				buttons: [
					{
						text: 'Yes',
						handler: function() {
							var loadMask = grid.showLoading('Removing...');													
							
							var options = {
								applyImmediately: applyNow,
								noReinvoice: !reInvoice
							};
							
							BillingService.getAccountService().deleteAdjustment(
								adjustmentGrid.detail.companyId, 
								record.adjustmentId,
								options
							).then(function(){
								loadMask.remove();
								window.DL.MessageUtil.showToast('Success', 'Removed Adjustment', {									
									theme: 'success'
								});
								actionRefresh();
							}, function(){
								loadMask.remove();
							});															
							
						}	
					},
					{
						text: 'No'
					}
				]
			});			
			
		};
		
	}
	
};
customElements.define('dl-account-adjustment-grid', AdjustmentGrid);

